export default __webpack_public_path__ + "static/media/icon3.8748d037.png";